<template>
  <div class="club-points-history-table-desktop">
    <div class="club-points-history-table-desktop__row">
      <div class="club-points-history-table-desktop__cell operation">
        <cell-label>Операция</cell-label>
      </div>
      <div class="club-points-history-table-desktop__cell date">
        <vue-client-only>
          <cell-label>{{ adaptive.isDesktop ? 'Дата операции' : 'Дата' }}</cell-label>
        </vue-client-only>
      </div>
      <div class="club-points-history-table-desktop__cell sum">
        <cell-label>Остаток</cell-label>
      </div>
      <div class="club-points-history-table-desktop__cell description">
        <cell-label>Подробнее</cell-label>
      </div>
      <div class="club-points-history-table-desktop__cell burnsAt">
        <cell-label>Дата сгорания</cell-label>
      </div>
    </div>

    <div
      v-for="(record, index) in historyRecords"
      :key="index"
      class="club-points-history-table-desktop__row"
    >
      <div class="club-points-history-table-desktop__cell operation">
        <points
          :value="record.bonusesUsed"
          :is-add-mode="record.bonusesUsed > 0"
        />
      </div>
      <div class="club-points-history-table-desktop__cell date">
        <cell-value>
          {{ valueOrEmpty(formatDate(record.date)) }}
        </cell-value>
      </div>
      <div class="club-points-history-table-desktop__cell sum">
        <cell-value>
          {{ valueOrEmpty($options.filters.price(record.bonusesTotal)) }}
        </cell-value>
      </div>
      <div class="club-points-history-table-desktop__cell description">
        <cell-value>
          <history-description
            :description="valueOrEmpty(record.description)"
            :order-number="record.orderNumber"
            :receipt="record.receipt"
          />
        </cell-value>
      </div>
      <div class="club-points-history-table-desktop__cell burnsAt">
        <cell-value>
          {{ valueOrEmpty(formatDate(record.dateEnd)) }}
        </cell-value>
      </div>
    </div>
  </div>
</template>

<script>
import VueClientOnly from 'vue-client-only';
import { ddmmyyyy } from '@/utils/date-to-string';
import CellLabel from '@/components/account/club-table/label.vue';
import CellValue from '@/components/account/club-table/value.vue';
import Points from '@/components/account/club-table/points.vue';
import HistoryDescription from '@/components/account/club-table/history-description.vue';

export default {
  name: 'club-points-history-table-desktop',

  components: {
    CellLabel,
    CellValue,
    Points,
    HistoryDescription,
    VueClientOnly,
  },

  inject: ['adaptive'],

  props: {
    historyRecords: {
      type: Array,
      default: () => [],
    }
  },

  methods: {
    formatDate(dateISOstring) {
      return ddmmyyyy(new Date(dateISOstring));
    },
    valueOrEmpty(value) {
      return value || `&mdash;`;
    },
  },
}
</script>

<style lang="scss">
  .club-points-history-table-desktop {
    &__row {
      display: flex;
      border-bottom: 1px solid $gray_lu;
      padding: 16px 0;

      & > * {
        padding-right: 8px;

        &:last-child {
          padding-right: 0;
        }
      }

      &:last-child {
        border-bottom: 0;
      }
    }

    &__cell {
      flex: 1;

      &.operation {
        flex: 0 1 17%;
      }
      &.date {
        flex: 0 1 15%;
      }
      &.sum {
        flex: 0 1 14%;
      }
      &.description {
        flex: 0 1 38%;
      }
      &.burnsAt {
        text-align: right;
        flex: 1 1 120px;
      }
    }
  }
</style>